import styled from 'styled-components';
import { Checkbox as antdCheckbox } from 'antd';

const Checkbox = styled(antdCheckbox)``;

export { Checkbox };
